import {aiSvgGeneratorServerlessUrl} from '../constants'
import {postForMedia} from '../utils'
import type {UserRequestInfo} from '@wix/document-services-types'

interface SvgParam {
    hint: string
}

interface SvgParams {
    svgs: Record<string, SvgParam>
    businessTerm: string
    siteDescription: string
    iconStyle: string
    userRequestInfo?: UserRequestInfo
}

export const fetchSvgs = async (serverFacade: any, paramsMap: SvgParams): Promise<string> =>
    postForMedia<string>(serverFacade, aiSvgGeneratorServerlessUrl, paramsMap)
